import React, { useState } from "react";
import { func, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TextField from "../../atoms/TextField";
import Button from "../../atoms/Button";
import ProthomFamilyView from "../../atoms/ProthomFamilyView";
import MessageView from "../../atoms/MessageView";
import WithSSO from "../../with-sso";

import { forgotPassword } from "../../helper/api";
import { isValidEmail } from "../../utils/utils";
import { setLoading } from "../../helper/actions";

import { RedIconWithText } from "../../molecules/RedIconwithtext";

import "./forgotPassword.m.css";

const VERIFY_EMAIL_MESSAGE = "Please check your email to finish with password reset process";

const ForgotPassword = ({ setLoading, authHost, navigateToPage, sketchesHost }) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const setData = e => {
    setEmail(e.target.value);

    // If error has been set then remove it
    if (e.target.value && emailError) {
      setEmailError("");
    }

    if (e.target.value && error) {
      setError(null);
    }

    if (e.target.value && success) {
      setSuccess(null);
    }
  };

  const onSubmitClick = event => {
    event.preventDefault();

    // true -> field errors, false - no fields errors
    if (validate()) {
      return;
    }

    setLoading(true);

    forgotPassword(email)
      .then(() => setSuccess(VERIFY_EMAIL_MESSAGE))
      .catch(ex => setError(ex.message))
      .finally(() => setLoading(false));
  };

  const validate = () => {
    let flag = false;

    if (!email) {
      setEmailError("Email field cannot be left blank !!");
      flag = true;
    } else if (!isValidEmail(email)) {
      setEmailError("Invalid Email !!");
      flag = true;
    }

    return flag;
  };

  return (
    <div styleName="top-container">
      <form onSubmit={onSubmitClick}>
        <div styleName="container">
          <div styleName="wrapper">
            <div styleName="forgot-pwd-message">Enter the email address to reset your password</div>

            <TextField
              value={email}
              error={emailError}
              placeholder="who@areyou.com"
              type="email"
              inputType="type2"
              name="email"
              onChange={setData}
            />

            <MessageView type={error ? "error" : "success"} text={error || success} />

            <Button content="CONTINUE" type="submit" buttonType="type3" />

            <span styleName="new-user">
              New to Prothom Alo?{" "}
              <WithSSO
                ssoHost={authHost}
                signUpPath="/sign-up-page"
                redirectUrl={sketchesHost}
                callbackUrl={sketchesHost}
              >
                {({ signUpHref }) => (
                  <a styleName="signup" href={signUpHref}>
                    Create an account
                  </a>
                )}
              </WithSSO>
            </span>
          </div>

          <div styleName="terms-privacy">
            By proceeding, you agree to the Prothom Alo’s <br /> <a styleName="terms-privacy-link">Terms of Use</a> and{" "}
            <a styleName="terms-privacy-link">Privacy Policy</a>
          </div>
          <ProthomFamilyView />
        </div>
      </form>
      <div styleName="red-icon-container">
        <RedIconWithText />
      </div>
    </div>
  );
};

ForgotPassword.propTypes = {
  navigateToPage: func,
  setLoading: func,
  authHost: string,
  sketchesHost: string
};

const mapStateToProps = state => ({
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
  sketchesHost: get(state, ["qt", "config", "sketches-host"], "https://www.prothomalo.com")
});

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url),
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
